(function($) {
    $.getPostalCodeInfo = function (postalCode, callback) {
        if (!postalCode || postalCode.length !== 4 || $.isNumeric(postalCode) === false) {
            if (callback) {
                callback({ result: "Ugyldig postnummer", valid: false });
            }

            return;
        }

        if (postalCode.length === 4) {
            const url = "//fraktguide.bring.no/fraktguide/api/postalCode.json?pnr=" + postalCode + "&callback=?";
            $.getJSON(url, callback);
        }
    };
})(jQuery);